<template>
  <el-dialog :title="getTitle"
             :visible.sync="showTime"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="timeInfo"
               :rules="timeRules"
               ref="timeForm"
               label-width="110px"
               class="time-form">
        <el-form-item label="时间组名称："
                      prop="name">
          <el-input :disabled="!data.item"
                    v-model.trim="timeInfo.name"
                    placeholder="请输入时间组名称"></el-input>
        </el-form-item>
        <template v-if="!data.item">
          <el-form-item label="开始时间："
                        prop="startTime">
            <el-time-picker v-model="timeInfo.startTime"
                            format="HH:mm"
                            value-format="HH:mm"
                            placeholder="开始时间">
            </el-time-picker>
            <!-- <el-time-select v-model="timeInfo.startTime"
                            :picker-options="startProps"
                            placeholder="选择时间">
            </el-time-select> -->
          </el-form-item>
          <el-form-item label="结束时间："
                        prop="endTime">
            <el-time-picker v-model="timeInfo.endTime"
                            format="HH:mm"
                            value-format="HH:mm"
                            placeholder="结束时间">
            </el-time-picker>
            <!-- <el-time-select v-model="timeInfo.endTime"
                            :picker-options="{
                                    start: '00:00',
                                    step: '00:05',
                                    end: '23:55',
                                    minTime: timeInfo.startTime
                                  }"
                            placeholder="选择时间">
            </el-time-select> -->
          </el-form-item>
        </template>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/time_slot/edit'"
                 type="primary"
                 @click="handleConfirm('timeForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showTime: this.isShow,
      startProps: {
        start: '00:00',
        step: '00:05',
        end: '23:55'
      },
      timeInfo: {
        name: '',
        startTime: '',
        endTime: ''
      },
      timeRules: {
        name: [{ required: true, message: '请输入时间组名称' }],
        startTime: [{ required: true, message: '请选择时段' }],
        endTime: [{ required: true, message: '请选择时段' }]
      }
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加时段' : '编辑时段'
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getTimeInfo({ id: this.data.pId }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.timeInfo.name = data.name
            if (!this.data.item) {
              let targetData = data[this.data.id]
              let start = targetData.split(',')[0]
              let end = targetData.split(',')[1]
              this.timeInfo.startTime = start
              this.timeInfo.endTime = end
            }
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {}
          data.id = this.data.pId
          data.name = this.timeInfo.name
          if (!this.data.item) {
            data[this.data.id] = [
              this.timeInfo.startTime,
              this.timeInfo.endTime
            ].join(',')
          }
          fetch.editTime(data).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                let way = this.data.item === 'name' ? 'left' : 'right'
                this.handleCancel(way)
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        }
      })
    },
    handleCancel(way) {
      this.$emit('handleClose', way)
    }
  }
}
</script>

<style></style>
